/**
 * @desc 根据TOB客户名称列表查询
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.BusinessCustomerDetailResponseDto>
>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/businessCustomer/getByNameList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
